import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { RoleService } from './../services/role.service';

@Component({
  selector: 'app-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.css']
})
export class MobileComponent implements OnInit {
  //check module permission
  module_name:any='SOA_Images';
  user_id: any='';
  role_id: any='';
  company_id: any='';
  APIKEY:any= '';

  constructor( private _router : Router,
    private _role:RoleService,
  ) { }

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.role_id =localStorage.getItem('role_id');
    this.APIKEY =localStorage.getItem('APIKEY');
    
    const data={
      module:this.module_name,
      role_id:this.role_id,
      company_id:this.company_id,
      APIKEY:this.APIKEY,
    };

    this._role.getUserModulePer(data)
    .subscribe(
      res => { 
        if(res.data.permission=='no'){
          this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('//setting/user-profile');
          });
        }
      },
    );
  }

}
